import { USERS_FETCHED, LOG_OUT } from "../types";

const INITIAL_STATE = [];

export default function users(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case USERS_FETCHED:
      return action.data;
    case LOG_OUT:
      return INITIAL_STATE;
    default:
      return state;
  }
}
